import { Component, Injector, Input, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * Tenure Widget
 */
@Component({
  selector: 'tenure-widget',
  templateUrl: './tenure-widget.component.html',
  styleUrls: ['./tenure-widget.component.scss', '../../common/css/general.scss']
})
export class TenureWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'tenure', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler('tenure', this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadMockup('tenure');

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('tenure', this.getReport());
  }

  /**
   * Called by base class to let widget preprocess loaded data if required
   */
  preprocessLoadedData(data) {

    data.supportTenure.forEach((st) => {
      st.checked = false;
      st.supportTenureData.forEach((std) => {
        std.checked = false;
      });
    });

    return data;
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

  /**
   * Checks if row is empty
   * @param _section {any} Section
   * @param row {any} Row
   */
  isRowEmpty(_section, row) {

    if (this.page.editMode) {
      return false;//nothing is empty in edit mode
    }

    const isValueEmpty = (value) => (value == null || value == "" || value == "0" || value == 0);
    return isValueEmpty(row.sheet) && isValueEmpty(row.plot) && isValueEmpty(row.parcel) && isValueEmpty(row.section2);
  }

  /**
   * TenureOwner Add clicked event handler
   */
  tenureOwnerAddClicked() {
    this.setDirtyFlag(true);
    const row: any = {
      oid: 0,
      reportId: this.getReport(),
      owner: '',
      supportTenureData: [],
      checked: false
    };

    this.widgetData.supportTenure.push(row);
  }

  /**
   * TenureOwner Delete clicked event handler
   */
  tenureOwnerDeleteClicked() {
    this.setDirtyFlag(true);
    const checkedRows = this.widgetData.supportTenure.filter((val) => {
      return val.checked;
    });
    checkedRows.forEach((row) => {
      this.widgetData.supportTenure = this.widgetData.supportTenure.filter((item) => {
        return item !== row;
      });
    });
  }

  /**
   * TenureOwner Data Add clicked event handler
   * @param supportTenure {any} Tenure array
   */
  tenureOwnerDataAddClicked(supportTenure) {
    this.setDirtyFlag(true);
    const row: any = {
      oid: 0,
      sheet: '',
      plot: '',
      parcel: '',
      section2: '',
      checked: false
    };

    supportTenure.supportTenureData.push(row);
  }

  /**
   * TenureOwner Data Delete clicked event handler
   * @param supportTenure {any} Tenure array
   */
  tenureOwnerDataDeleteClicked(supportTenure) {
    this.setDirtyFlag(true);
    const checkedRows = supportTenure.supportTenureData.filter((val) => {
      return val.checked;
    });

    checkedRows.forEach((row) => {
      supportTenure.supportTenureData = supportTenure.supportTenureData.filter((item) => {
        return item !== row;
      });
    });
  }
}
